import * as React from 'react';
import { WEBSITE_MODE } from '@sitegen/common/constants';

const StandaloneOnly = (props: IStandaloneOnlyProps & React.ComponentPropsWithoutRef<'div'>): JSX.Element => {
    return (
        <>{props.mode === WEBSITE_MODE.STANDALONE ? props.children : null}</>
    );
};

interface IStandaloneOnlyProps {
    readonly mode: WEBSITE_MODE;
}

export default StandaloneOnly;
